import { apiServer } from 'settings/web-services/api';

export function getSearchThreadsAndMessagesByString({ search }) {
  return apiServer.get('/messages/threads/search', {
    params: {
      q: search,
    },
  });
}
